import MainComponent from "components/Main";

import ButtonIcon from "components/ButtonIcon";
import Table from "components/Table";
import Quest from "components/Quest";

import './index.less';
import './themes/default.less';

export default class ReportDay extends MainComponent {

    constructor(props) {
        super(props);

        this.initData();

        const { typeN } = this.props.info.urlProps;

        this.state = {
            ...this.state,
            viewTable: typeN || "accounts",
            isLeftmost: true,
            info: {},
            tableMap: this.getTableMap(),
            tableMap2: this.getTableMap(),
        };
    }

    initData() {
        this.itemsAccount1 = this.generateItemsAccount1();
        this.itemsAccount2 = this.generateItemsAccount2();
        this.itemsPayers = [];
    }

    generateItemsAccount1() {
        return [
            { value: "invoicesAmount", name: this.tr("report.amountInvoices"), sum: this._helper.number.toSum(0), prefix: "r", textTooltip: "tooltip.sumInv" },
            { value: "totalDebt", name: this.tr("report.totalReceipt"), sum: this._helper.number.toSum(0), prefix: "r", link: "totalReceipt", textTooltip: "tooltip.totalCash" },
            { value: "invoicesCount", name: this.tr("report.invoicesIssued"), sum: "0", prefix: "", textTooltip: "tooltip.numberInvoices" },
            { value: "totalRefund", name: this.tr("report.canceledAccounts"), sum: "0", prefix: "", textTooltip: "tooltip.numberCanceledInvoices" },
            { value: "totalPaid", name: this.tr("report.paid"), sum: this._helper.number.toSum(0), prefix: "r", textTooltip: "tooltip.paid" },
            { value: "totalDuty", name: this.tr("report.debt"), sum: this._helper.number.toSum(0), prefix: "r", sumColor: "red", textTooltip: "tooltip.debt" },
            { value: "balance", name: this.tr("report.advance"), sum: this._helper.number.toSum(0), prefix: "r", link: "payers", textTooltip: "tooltip.prepaid" },
            { value: "amortizationPaid", name: this.tr("report.repayment"), sum: this._helper.number.toSum(0), prefix: "r", sumColor: "red", textTooltip: "tooltip.returnedDebt" },
            { value: "totalExpenses", name: this.tr("report.amountExpenses"), sum: this._helper.number.toSum(0), prefix: "r", textTooltip: "tooltip.expenses" },
            { value: "total", name: this.tr("report.totalDay"), sum: this._helper.number.toSum(0), prefix: "r", textTooltip: "tooltip.total" },
        ];
    }

    generateItemsAccount2() {
        return [
            { value: "visitsCount", name: this.tr("report.totalVisits"), sum: "0", textTooltip: "tooltip.visits" },
            { value: "newClientsCount", name: this.tr("report.newPatients"), sum: "0", textTooltip: "tooltip.amountNewPatients" },
            { value: "primaryTookPlace", name: this.tr("report.primaryPatients"), sum: "0", textTooltip: "tooltip.primaryPatients" },
            { value: "doctorsLoading", name: this.tr("report.averageDoctors"), sum: "0", textTooltip: "tooltip.averageLoadDoctors", prefix: "p" },
            { value: "percentValue", name: this.tr("report.averageSeat"), sum: "0", textTooltip: "tooltip.averageLoadSeat", prefix: "p" },
        ];
    }

    componentDidMount() {
        this.refresh();
    }

    componentDidUpdate(prevProps) {
        if (this.props.selectedStartDate !== prevProps.selectedStartDate ||
            this.props.selectedEndDate !== prevProps.selectedEndDate) {
            this.refresh();
        }
    }

    refresh() {
        const { viewTable } = this.state;
        this.loadReport(viewTable);
    }

    async getData(table) {
        const { clinicId } = this.props.info;
        const { getFormatDate } = this.props.events;
        const { dateFrom, dateTo } = getFormatDate();

        const info = {
            clinicId,
            dateFrom,
            dateTo,
        };

        let source = "";
        if (table === "accounts")
            source = "daily-report";
        else if (table === "totalReceipt")
            source = "daily-payments-by-type";
        else if (table.includes("funds")) {
            info.paymentWayId = table.replace("funds", "");
            source = "daily-payments-with-type-by-client";
        } else if (table === "payers") {
            source = "daily-advance-by-client";
        }

        const resp = dateFrom !== dateTo ?
            await this._request.report.getMultiRow(source, info) :
            await this._request.report.getOneRow(source, info);

        if (table === "accounts" && dateFrom === dateTo) {
            source = "daily-report-visits";
            const resp2 = await this._request.report.getOneRow(source, info);
            resp.data.data2 = {};

            if (resp?.data && resp2?.data)
                resp.data.data2 = resp2.data;

        }
        this.props.events.setClinics([]);

        return resp?.data;
    }

    getValue(prefix, value) {
        return prefix === "r" ? this._helper.number.toSum(value) : prefix === "p" ? value + " %" : value;
    }

    setTable(table, type, map, data, defaultInfo) {
        if (type === "multy") {
            table = table.map(it => {
                Object.keys(map).forEach(name => {
                    const summs = data[name] ? data[name] : defaultInfo;
                    it[name] = this.getValue(it.prefix, summs[it.value]);
                });
                return it;
            });
        } else {
            table = table.map(it => {
                it.sum = this.getValue(it.prefix, data[it.value]);
                return it;
            });
        }
    }

    setInfoInTableAccounts(data, type) {
        let { tableMap } = this.state;
        const { getFormatDate } = this.props.events;
        const { dateFrom, dateTo } = getFormatDate();

        if (type === "multy") {
            tableMap.name.size = "300px";
            tableMap.name.style = "white";
            tableMap.name.styleHeader = "white";
            const map = this.generingMap();
            tableMap = { ...tableMap, ...map };
            delete tableMap.sum;

            const defaultInfo = {
                invoicesAmount: 0,
                totalDebt: 0,
                invoicesCount: 0,
                totalRefund: 0,
                totalPaid: 0.00,
                totalDuty: 0.00,
                balance: 0,
                amortizationPaid: 0.00,
                totalExpenses: 0.00,
                total: 0
            };

            this.setTable(this.itemsAccount1, type, map, data, defaultInfo);
        } else {
            tableMap = this.getTableMap();
            this.setTable(this.itemsAccount1, type, [], data, false);
            if (dateFrom === dateTo)
                this.setTable(this.itemsAccount2, type, [], data.data2, false);
        }

        return tableMap;
    }

    setInfoInTableReceipt(data, type) {
        //let { tableMap } = this.state;
        let tableMap = {
            name: {
                label: "report.fundsChannel",
                callback: this.raporNameCell.bind(this),
                style: "white",
                styleHeader: "white",
            }
        };
        if (type === "multy") {
            tableMap.name.size = "300px";
            const map = this.generingMap();
            tableMap = { ...tableMap, ...map };
            delete tableMap.sum;

            const tempTable = [];
            Object.keys(data).forEach(date => {
                data[date].forEach(payType => {
                    if (!tempTable.find(row => row.value === payType.entityId)) {
                        tempTable.push({
                            value: payType.entityId,
                            name: payType.entityTitle,
                            link: `funds${payType.entityId}`,
                        });
                    }
                });
            });

            this.itemsTotalReceipt = tempTable.map(row => {
                Object.keys(data).forEach(date => {
                    let sum = 0;
                    const payType = data[date].find(it => it.entityId === row.value);
                    if (payType)
                        sum = payType.value;

                    row[date] = this.getValue("r", sum);
                });
                return row;
            });

        } else {
            tableMap = this.getTableMap();
            tableMap.sum.label = "main.sum";
            tableMap.sum.hideLabel = false;
            let sum = 0;
            this.itemsTotalReceipt = data.map(it => {
                const row = {
                    value: it.entityId,
                    name: it.entityTitle,
                    sum: this.getValue("r", it.value),
                    link: `funds${it.entityId}`,
                };
                sum += +it.value;
                return row;
            });
            this.itemsTotalReceipt.push({
                value: "total",
                name: this.tr("report.total"),
                sum: this.getValue("r", sum),
                bold: true,
            });

        }

        return tableMap;
    }

    setInfoInTablePayers(data, type) {
        let tableMap = {
            name: {
                label: "clientStatuses.PERMANENT",
                callback: this.raporNameCell.bind(this),
                style: "white",
                styleHeader: "white",
            }
        };

        if (type === "multy") {
            tableMap.name.size = "300px";
            const map = this.generingMap();
            tableMap = { ...tableMap, ...map };
            delete tableMap.sum;

            const tempTable = [];
            Object.keys(data).forEach(date => {
                data[date].forEach(payType => {

                    if (!tempTable.find(row => row.value === payType.entityId)) {
                        tempTable.push({
                            value: payType.entityId,
                            name: payType.entityTitle,
                            linkClient: payType.entityId
                        });
                    }
                });
            });

            this.itemsPayers = tempTable.map(row => {
                Object.keys(data).forEach(date => {
                    let sum = 0;
                    const payType = data[date].find(it => it.entityId === row.value);
                    if (payType)
                        sum = payType.value;

                    row[date] = this.getValue("r", sum);
                });
                return row;
            });
        } else {
            tableMap = this.getTableMap();
            tableMap.sum.label = "main.sum";
            tableMap.sum.hideLabel = false;

            this.itemsPayers = data.map(it => {
                const row = {
                    value: it.entityId,
                    name: it.entityTitle,
                    prefix: true,
                    sum: this.getValue("r", it.value),
                    linkClient: it.entityId
                };
                return row;
            });

        }

        return tableMap;
    }

    setInfoInTable(data, viewTable) {
        const { selectedEndDate } = this.props;
        const type = selectedEndDate ? "multy" : "one";

        let tableMap;
        if (viewTable === "totalReceipt")
            tableMap = this.setInfoInTableReceipt(data, type);
        else if (viewTable.includes("funds"))
            tableMap = this.setInfoInTablePayers(data, type, "funds");
        else if (viewTable.includes("payers"))
            tableMap = this.setInfoInTablePayers(data, type, "payers");
        else
            tableMap = this.setInfoInTableAccounts(data, type);

        this.setState({ info: data, tableMap, viewTable });

    }

    async loadReport(table) {
        const { setPageProps } = this.props.events;
        setPageProps({ typeN: table });

        this._helper.showLoading();

        const data = await this.getData(table);
        if (data)
            this.setInfoInTable(data, table);

        this._helper.hideLoading();
    }

    generingMap() {
        const { selectedStartDate, selectedEndDate } = this.props;
        const currentDate = new Date(selectedStartDate);
        let obj = {};
        while (currentDate <= selectedEndDate) {
            const name = this._helper.date.toStr(currentDate, 'YYYY-MM-DD');
            const label = this._helper.date.toStr(currentDate, 'DD.MM');
            obj = {
                ...obj, [name]: {
                    label: label,
                    size: "100px",
                    callback: this.raporSumCell.bind(this)
                }
            };
            currentDate.setDate(currentDate.getDate() + 1);
        }
        return obj;
    }

    getTableMap() {
        const tableMap = {
            name: {
                label: "report.accountsFinance",
                callback: this.raporNameCell.bind(this),
            },
            sum: {
                label: "main.sum",
                hideLabel: true,
                callback: this.raporSumCell.bind(this),
                size: "100px",
            },
        };
        return tableMap;
    }

    raporSumCell(value, it, info) {
        const { sumColor, bold } = info;
        const color = sumColor ? sumColor : "";
        const bl = bold ? "text p1SemiBold" : "";
        return (<div className={`raporSumCell ${color} ${bl}`}>{value}</div>);
    }

    onOpenDetails(link) {
        this.loadReport(link);
    }

    openClient(id, props) {
        this._helper.openClient(id, props);
    }

    raporNameCell(value, it, info) {
        const { textTooltip, link, linkClient } = info;

        const color = (link || linkClient) ? "link" : "";
        const props = {};

        if (info.link) {
            props.onClick = this.onOpenDetails.bind(this, info.link);
        } else if (info.linkClient) {
            props.onClick = this.openClient.bind(this, info.linkClient, { tab: "invoices" });
        }

        return (<div className="flex gap24" {...props}>
            {textTooltip && <Quest textTooltip={textTooltip} />}
            <div className={`raporNameCell ${color} ${info.link ? "hand" : ""}`}>{value}</div>
        </div>);
    }

    handleScrollX(scrollLeft) {
        //const { isLeftmost } = this.state;

        /*
        перписать что бы стэйты ушли в таблицу
        if (scrollLeft === 0 && !isLeftmost)
            this.changeState("isLeftmost", true);
        else if (isLeftmost)
            this.changeState("isLeftmost", false);
            */

    }

    renderTableAccounts() {
        const { selectedEndDate } = this.props;
        const { isLeftmost, tableMap, viewTable, tableMap2 } = this.state;
        tableMap2.name.label = "client.visits";

        const items = viewTable === "totalReceipt" ? this.itemsTotalReceipt :
            (viewTable.includes("funds") || viewTable === "payers") ? this.itemsPayers : this.itemsAccount1;

        return (selectedEndDate ? <div className={`conT flex flex1 ${!isLeftmost ? "shadow" : ""}`} >
            <Table
                map={tableMap}
                headBlack1={true}
                headTitle={true}
                handleScrollX={this.handleScrollX.bind(this)}
                items={items}
            />
        </div> : <div className="flex flex1 gap16">
            <div className="flex flex1">
                <Table
                    map={tableMap}
                    headBlack1={true}
                    headTitle={true}
                    items={items}
                />
            </div>
            {viewTable === "accounts" && <div className="flex flex1">
                <Table
                    map={tableMap2}
                    headBlack1={true}
                    headTitle={true}
                    items={this.itemsAccount2}
                />
            </div>}
        </div>);
    }

    onReturnBack() {
        const { viewTable } = this.state;

        if (viewTable.includes("funds")) {
            this.loadReport("totalReceipt");
        } else if (viewTable === "totalReceipt" || viewTable === "payers") {
            this.loadReport("accounts");
        }
    }

    getHeaderText() {
        const { selectedStartDate, selectedEndDate } = this.props;
        const sdate = this._helper.date.toStr(selectedStartDate, 'DD MMMM YYYY');
        const sdateshort = this._helper.date.toStr(selectedStartDate, 'DD MMMM');
        if (selectedEndDate !== null) {
            const edate = this._helper.date.toStr(selectedEndDate, 'DD MMMM YYYY');
            return `${this.tr("report.periodReportFor")} ${sdateshort} - ${edate}`;
        }

        return `${this.tr("report.dailyReportFor")} ${sdate}`;
    }

    render() {
        const { viewTable } = this.state;

        return (<>
            <div className="flex between">
                <div className="flex gap16">
                    {viewTable !== "accounts" && <ButtonIcon name="arrowLeft" onClick={this.onReturnBack.bind(this)} />}
                    <div>
                        <div className="text blockTitle">{this.getHeaderText()}</div>
                        <div className="comment text p2">{`${this.tr("report.formed")} ${this._helper.date.toStr(new Date(), 'DD.MM.YYYY HH:mm')}`}</div>
                    </div>
                </div>
            </div>
            {this.renderTableAccounts()}
        </>);
    }
}
